<script>
    import {scaleColor} from "../scaleColor";
    let scaleClass
    export {scaleClass as class}
</script>

<div class={scaleClass}>
    <p>Less commits</p>
    <div class="github-color-scale-cells">
        {#each scaleColor as color}
            <div class={`github-color-scale-cell table-cell-background-${color}`}></div>
        {/each}
    </div>
    <p>More commits</p>
</div>

<style lang="scss">
    @import '../githubSection';
</style>